import AWSIoTData from 'aws-iot-device-sdk';

export function makeClient(email) {
    const clientId = `raven-web-app?${email}@${Date.now()}`;
    return AWSIoTData.device({
        clientId,
        region: window.AWS.config.region,
        keepalive: 30,
        host: process.env.REACT_APP_IOT_MQTT_HOST,
        protocol: 'wss', //mqtts
        maximumReconnectTimeMs: 30000,
        debug: false,
        accessKeyId: window.AWS.config.credentials.accessKeyId,
        secretKey: window.AWS.config.credentials.secretAccessKey,
        sessionToken: window.AWS.config.credentials.sessionToken,
    });
}
